import { Textarea } from '@orobix/orobix-fe-components'
import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

export interface TrainingNotesProps {
  fieldName: string
}

type E = React.ChangeEvent<HTMLTextAreaElement>

const TrainingNotes = ({ fieldName }: TrainingNotesProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField(fieldName)

  const { name, value } = field
  const { error, touched } = meta
  const { setValue, setTouched } = helpers

  return (
    <div id="divTrainingNotesId">
      <Textarea
        name={name}
        id={name}
        label={t('Notes')}
        type="text"
        value={value}
        onChange={(e: E) => setValue(e.target.value)}
        onBlur={() => setTouched(true)}
        disabled={isSubmitting}
        error={!!(error && touched)}
        errorMessage={error}
        maxLength={255}
        rows={3}
      />
    </div>
  )
}

export default TrainingNotes
